import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// Ask Suvnedra sir , about exporting masterial module
// Remove this mat datepicker input from here..--- Call it from module
import { MatDatepickerInputEvent } from '@angular/material';
// import { MatDatepickerInputEvent } from '../../modules/material/material.module';

@Component({
    selector: 'app-calender-tag',
    templateUrl: './calender-tag.component.html',
    styleUrls: ['./calender-tag.component.css']
})
export class CalenderTagComponent implements OnInit {

    public setMinDate: Date;
    public setMaxDate: Date;
    public startDate: Date;

    @Input() placeholderMsg: string;
    @Input() public minDateVal: string | Date;
    @Input() public maxDateVal: string | Date;
    @Input() public defaultDisplayDate: string | Date;
    @Input() public nameReceived: string;
    @Input() public classNameReceived: string;
    @Input() public formCotrolNameVal: string;
    @Output() emitCalVal = new EventEmitter<Date>();

    // pipie operator wil check null and undefined
    // babel -> to vaniall js
    constructor() {
    }


    ngOnInit() {
        // Value will only be obtained
        this.setMinDate = this.parse(this.minDateVal || new Date());
        this.setMaxDate = this.parse(this.maxDateVal || new Date());
        this.startDate = this.parse(this.defaultDisplayDate || new Date());
    }

    // Transmitting  Calender date time object

    updateCalVal(type: string, event: MatDatepickerInputEvent<Date>) {
        this.emitCalVal.emit(event.value);
    }

    /* Ask suvenedra sir, whther services required or it is fine here -since every time value
    will reach here and then it will be parsed */

    /* Convert string to Date time object */

    parse(value: any): Date | null {

        if ((typeof value === 'string') && (value.includes('/'))) {
            const str = value.split('/');

            const year = Number(str[2]);
            const month = Number(str[1]) - 1;
            const date = Number(str[0]);

            return new Date(year, month, date);
        } else if ((typeof value === 'string') && value === '') {
            return new Date();
        }

        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }




}
